export const apiBase = 'https://followup.mkowalski.dev/api';
export const websiteUrl = 'https://followup.social';
